<template>
  <div class="home">
    <BackButton @click="goBack" />
    <div class="active_block" v-if="active">
      <img :src="active.img" class="currency_logo" />
      <span class="balance_text">{{ $t("yourAssetBalance", { name: active.name }) }}</span>
      <div class="balanceBlock">
        <p>
          {{ parseFloat(active.fiat_value).toFixed(2).split(".")[0] }},<span>{{ parseFloat(active.fiat_value).toFixed(2).split(".")[1] }}</span>
        </p>
        <span>{{ currency }}</span>
      </div>
      <span class="balance_text">{{ active.amount }} {{ active.symbol }}</span>
      <div class="buttons">
        <div class="button" @click="$router.push(`/active/${active.symbol.toLowerCase()}/deposit`)">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="8.25" y="9" width="20" height="21" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.875 18C1.875 9.09441 9.09441 1.875 18 1.875C26.9056 1.875 34.125 9.09441 34.125 18C34.125 26.9056 26.9056 34.125 18 34.125C9.09441 34.125 1.875 26.9056 1.875 18ZM18.75 12C18.75 11.5858 18.4142 11.25 18 11.25C17.5858 11.25 17.25 11.5858 17.25 12V22.1893L14.0303 18.9697C13.7374 18.6768 13.2626 18.6768 12.9697 18.9697C12.6768 19.2626 12.6768 19.7374 12.9697 20.0303L17.4697 24.5303C17.7626 24.8232 18.2374 24.8232 18.5303 24.5303L23.0303 20.0303C23.3232 19.7374 23.3232 19.2626 23.0303 18.9697C22.7374 18.6768 22.2626 18.6768 21.9697 18.9697L18.75 22.1893V12Z"
              fill="#007AFF"
            />
          </svg>
          <span>{{ $t("deposit") }}</span>
        </div>
        <div class="button" @click="$router.push(`/active/${active.symbol.toLowerCase()}/withdraw`)">
          <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="11.25" y="10" width="14" height="16" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M34.625 18C34.625 26.9056 27.4056 34.125 18.5 34.125C9.59441 34.125 2.375 26.9056 2.375 18C2.375 9.09441 9.59441 1.875 18.5 1.875C27.4056 1.875 34.625 9.09441 34.625 18ZM17.75 24C17.75 24.4142 18.0858 24.75 18.5 24.75C18.9142 24.75 19.25 24.4142 19.25 24L19.25 13.8107L22.4697 17.0303C22.7626 17.3232 23.2374 17.3232 23.5303 17.0303C23.8232 16.7374 23.8232 16.2626 23.5303 15.9697L19.0303 11.4697C18.8897 11.329 18.6989 11.25 18.5 11.25C18.3011 11.25 18.1103 11.329 17.9697 11.4697L13.4697 15.9697C13.1768 16.2626 13.1768 16.7374 13.4697 17.0303C13.7626 17.3232 14.2374 17.3232 14.5303 17.0303L17.75 13.8107L17.75 24Z"
              fill="#007AFF"
            />
          </svg>
          <span>{{ $t("withdraw") }}</span>
        </div>
      </div>
      <div class="history_block">
        <span class="history_head">{{ $t("operation_history") }}</span>
        <div class="transactions_list" v-if="transactions?.length > 0">
          <div class="transaction" v-for="t of transactions" :key="t.date">
            <span class="date_name">{{ localizeDate(t.date) }}</span>
            <div class="history_transactions">
              <div class="trans" v-for="(h, index) of t.items" :key="h.id">
                <div class="trans_block">
                  <img :src="icon(h)" />
                  <div class="trans_text_block">
                    <div class="trans_line">
                      <span class="trans_type">{{ h.type === "buy" ? $t("deposit2") : $t("withdraw2") }}</span>
                      <span class="trans_amount" :class="h.type == 'buy' ? 'deposit' : 'withdraw'">{{ h.type === "buy" ? "+" : "-" }} {{ h.crypto_amount }} {{ active.symbol }}</span>
                    </div>
                    <div class="trans_line">
                      <span class="trans_date">{{ formatTimestampShort(h.date) }}</span>
                      <span class="trans_fiat">{{ h.fiat_amount }} {{ h.currency }}</span>
                    </div>
                  </div>
                </div>
                <div class="separator" v-if="index < t.items.length - 1"></div>
              </div>
              <!-- Граница между операциями -->
            </div>
          </div>
        </div>
        <span class="empty_history" v-else>{{ $t("noHistory") }}</span>
      </div>
    </div>
    <div class="active_block" v-else>
      <span>{{ $t("loading") }}</span>
    </div>
  </div>
</template>
<script>
import { UserManager } from "@/utils/userManager";
import { getDateLocale } from "@/utils/apiErrors";
import axios from "axios";
import { BackButton } from "vue-tg";
export default {
  data() {
    return {
      user: null,
      botId: null,
      currency: this.$store.getters.getCurrency,
      active: null,
      transactions: null, // Will be set by getTransactions
      // transactions: [
      //   {
      //     id: 1,
      //     user_id: 12345,
      //     date: 1754089200,
      //     type: "deposit",
      //     asset: "Bitcoin",
      //     amount: 0.5,
      //     currency: "BTC",
      //     fiat_amount: 30000.0,
      //   },
      //   {
      //     id: 2,
      //     user_id: 12345,
      //     date: 1754092800,
      //     type: "withdraw",
      //     asset: "Bitcoin",
      //     amount: 0.2,
      //     currency: "BTC",
      //     fiat_amount: 12000.0,
      //   },
      //   {
      //     id: 3,
      //     user_id: 12345,
      //     date: 1754175600,
      //     type: "deposit",
      //     asset: "Bitcoin",
      //     amount: 0.1,
      //     currency: "BTC",
      //     fiat_amount: 6000.0,
      //   },
      //   {
      //     id: 4,
      //     user_id: 12345,
      //     date: 1754182800,
      //     type: "withdraw",
      //     asset: "Bitcoin",
      //     amount: 0.05,
      //     currency: "BTC",
      //     fiat_amount: 3000.0,
      //   },
      //   {
      //     id: 5,
      //     user_id: 12345,
      //     date: 1754262000,
      //     type: "deposit",
      //     asset: "Bitcoin",
      //     amount: 0.3,
      //     currency: "BTC",
      //     fiat_amount: 18000.0,
      //   },
      //   {
      //     id: 6,
      //     user_id: 12345,
      //     date: 1754348400,
      //     type: "withdraw",
      //     asset: "Bitcoin",
      //     amount: 0.15,
      //     currency: "BTC",
      //     fiat_amount: 9000.0,
      //   },
      //   {
      //     id: 7,
      //     user_id: 12345,
      //     date: 1754355600,
      //     type: "deposit",
      //     asset: "Bitcoin",
      //     amount: 0.02,
      //     currency: "BTC",
      //     fiat_amount: 1200.0,
      //   },
      //   {
      //     id: 8,
      //     user_id: 12345,
      //     date: 1754442000,
      //     type: "withdraw",
      //     asset: "Bitcoin",
      //     amount: 0.01,
      //     currency: "BTC",
      //     fiat_amount: 600.0,
      //   },
      //   {
      //     id: 9,
      //     user_id: 12345,
      //     date: 1754528400,
      //     type: "deposit",
      //     asset: "Bitcoin",
      //     amount: 0.25,
      //     currency: "BTC",
      //     fiat_amount: 15000.0,
      //   },
      //   {
      //     id: 10,
      //     user_id: 12345,
      //     date: 1754535600,
      //     type: "withdraw",
      //     asset: "Bitcoin",
      //     amount: 0.03,
      //     currency: "BTC",
      //     fiat_amount: 1800.0,
      //   },
      // ],
    };
  },
  methods: {
    goBack() {
      window.history.back();
    },
    initializeUser() {
      const storedUser = this.$store.getters.getTgUserData;
      const storedBotId = this.$store.getters.getBotId;
      if (storedUser && storedBotId) {
        this.user = storedUser;
        this.botId = storedBotId;
      } else {
        const userContext = UserManager.getFullUserContext();
        this.user = userContext.user;
        this.botId = userContext.botId;
        this.$store.commit("setTgUserData", this.user);
        this.$store.commit("setBotId", this.botId);
      }
    },
    icon(h) {
      return require(`../assets/icons/${h.type}_icon.svg`);
    },
    groupAndSortHistoryByDate(history) {
      console.log("[GROUP_SORT] groupAndSortHistoryByDate called");
      console.log("[GROUP_SORT] Input history:", history);
      console.log("[GROUP_SORT] Input history type:", typeof history);
      console.log("[GROUP_SORT] Input history is array:", Array.isArray(history));
      console.log("[GROUP_SORT] Input history length:", history?.length);
      
      if (!history) {
        console.error("[GROUP_SORT] History is null or undefined!");
        return [];
      }
      
      if (!Array.isArray(history)) {
        console.error("[GROUP_SORT] History is not an array!", typeof history);
        return [];
      }
      
      if (history.length === 0) {
        console.log("[GROUP_SORT] History is empty array");
        return [];
      }
      
      // Шаг 1: Группируем по дате YYYY-MM-DD
      console.log("[GROUP_SORT] Starting grouping...");
      const grouped = history.reduce((acc, item, index) => {
        console.log(`[GROUP_SORT] Processing item ${index}:`, item);
        
        if (!item.date) {
          console.warn(`[GROUP_SORT] Item ${index} has no date field:`, item);
          return acc;
        }
        
        const date = new Date(item.date * 1000);
        console.log(`[GROUP_SORT] Item ${index} date (timestamp):`, item.date);
        console.log(`[GROUP_SORT] Item ${index} date (Date object):`, date);
        
        if (isNaN(date.getTime())) {
          console.error(`[GROUP_SORT] Item ${index} has invalid date:`, item.date);
          return acc;
        }
        
        const dateKey = date.toISOString().split("T")[0]; // 'YYYY-MM-DD'
        console.log(`[GROUP_SORT] Item ${index} dateKey:`, dateKey);

        if (!acc[dateKey]) {
          acc[dateKey] = [];
        }

        acc[dateKey].push(item);
        console.log(`[GROUP_SORT] Item ${index} added to group ${dateKey}, group size:`, acc[dateKey].length);

        return acc;
      }, {});
      
      console.log("[GROUP_SORT] Grouped object:", grouped);
      console.log("[GROUP_SORT] Grouped keys:", Object.keys(grouped));

      // Шаг 2: Преобразуем объект в массив и сортируем по дате (по убыванию)
      console.log("[GROUP_SORT] Starting sorting...");
      const sortedArray = Object.entries(grouped)
        .map(([dateKey, items]) => {
          console.log(`[GROUP_SORT] Mapping dateKey:`, dateKey, "items:", items);
          return {
            date: dateKey,
            items: [...items],
          };
        })
        .sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          const result = dateB - dateA;
          console.log(`[GROUP_SORT] Sorting: ${a.date} vs ${b.date}, result:`, result);
          return result; // Сортировка по дате (убывание)
        });

      console.log("[GROUP_SORT] Sorted array:", sortedArray);
      console.log("[GROUP_SORT] Sorted array length:", sortedArray.length);
      return sortedArray;
    },
    localizeDate(isoDateStr) {
      const date = new Date(isoDateStr);

      // Определяем, текущий ли это год
      const currentYear = new Date().getFullYear();
      const isCurrentYear = date.getFullYear() === currentYear;

      // Настройки формата
      const optionsThisYear = { month: "long", day: "numeric" }; // Например: "9 июня"
      const optionsOtherYears = { year: "numeric", month: "long", day: "numeric" }; // Например: "3 января 2023"

      // Форматируем
      const formatter = new Intl.DateTimeFormat(getDateLocale(this.$store.getters.getLanguage), isCurrentYear ? optionsThisYear : optionsOtherYears);
      return formatter.format(date);
    },
    formatTimestampShort(timestamp) {
      const date = new Date(timestamp * 1000); // JS работает с миллисекундами

      const options = {
        day: "numeric",
        month: "short", // 'февр.'
        hour: "2-digit",
        minute: "2-digit",
      };

      const formatter = new Intl.DateTimeFormat(getDateLocale(this.$store.getters.getLanguage), options);
      return formatter.format(date);
    },
    fetchActives() {
      console.log("[ACTIVE_COMPONENT] fetchActives called");
      const actives = this.$store.getters.getActives;
      console.log("[ACTIVE_COMPONENT] Store actives:", actives);
      const asset = this.$route.params.id.toUpperCase();
      console.log("[ACTIVE_COMPONENT] Asset from route:", asset);
      this.active = actives.find((i) => i.symbol == asset);
      console.log("[ACTIVE_COMPONENT] Found active in store:", this.active);
      this.getTransactions(asset);
      
      // Сначала получаем все доступные активы (не только те, что у пользователя)
      const listUrl = `${window.location.origin}/actives/list?bot_id=${this.botId}`;
      console.log("[ACTIVE_COMPONENT] Fetching all actives from:", listUrl);
      fetch(listUrl)
        .then((res) => {
          console.log("[ACTIVE_COMPONENT] All actives response status:", res.status);
          return res.json();
        })
        .then((listData) => {
          console.log("[ACTIVE_COMPONENT] All actives response data:", listData);
          
          // Ищем актив в общем списке
          const activeFromList = listData.actives?.find((i) => i.symbol == asset);
          console.log("[ACTIVE_COMPONENT] Found active in list:", activeFromList);
          
          if (activeFromList) {
            // Если актив найден в общем списке, используем его как базовую информацию
            this.active = {
              ...activeFromList,
              amount: 0, // По умолчанию 0, если нет в кошельке
              fiat_value: 0,
            };
            console.log("[ACTIVE_COMPONENT] Set active from list:", this.active);
          }
          
          // Теперь получаем активы пользователя для обновления amount и fiat_value
          const userUrl = `${window.location.origin}/actives/user/${this.botId}/${this.user.id}`;
          console.log("[ACTIVE_COMPONENT] Fetching user actives from:", userUrl);
          return fetch(userUrl);
        })
        .then((res) => {
          console.log("[ACTIVE_COMPONENT] User actives response status:", res.status);
          return res.json();
        })
        .then((userData) => {
          console.log("[ACTIVE_COMPONENT] User actives response data:", userData);
          
          // Ищем актив в активах пользователя
          const userActive = userData.actives?.find((i) => i.symbol == asset);
          console.log("[ACTIVE_COMPONENT] Found active in user actives:", userActive);
          
          if (userActive) {
            // Если актив есть у пользователя, обновляем amount и fiat_value
            this.active = {
              ...this.active,
              ...userActive,
            };
            console.log("[ACTIVE_COMPONENT] Updated active with user data:", this.active);
          } else if (!this.active) {
            // Если актив не найден ни в общем списке, ни у пользователя
            console.error("[ACTIVE_COMPONENT] Active not found in list or user actives!");
          }
          
          // Сохраняем активы пользователя в store
          this.$store.commit("setActives", userData.actives || []);
        })
        .catch((err) => {
          console.error("[ACTIVE_COMPONENT] Ошибка при загрузке активов:", err);
          
          // Если ошибка, но актив уже найден в общем списке, оставляем его
          if (!this.active) {
            console.error("[ACTIVE_COMPONENT] Failed to load actives and no active found!");
          }
        });
    },
    async getTransactions(asset) {
      console.log("[TRANSACTIONS] getTransactions called");
      console.log("[TRANSACTIONS] Parameters:", {
        asset,
        botId: this.botId,
        userId: this.user?.id,
        user: this.user,
      });
      
      if (!this.botId || !this.user?.id) {
        console.error("[TRANSACTIONS] Missing botId or userId:", {
          botId: this.botId,
          userId: this.user?.id,
        });
        return;
      }
      
      const url = `${window.location.origin}/market/history/${this.botId}/${this.user.id}?asset=${asset}&limit=50&offset=0`;
      console.log("[TRANSACTIONS] Request URL:", url);
      
      try {
        console.log("[TRANSACTIONS] Sending request...");
        const response = await axios.get(url);
        console.log("[TRANSACTIONS] Response received:", {
          status: response.status,
          statusText: response.statusText,
          headers: response.headers,
        });
        console.log("[TRANSACTIONS] Response data:", response.data);
        console.log("[TRANSACTIONS] Response data type:", typeof response.data);
        console.log("[TRANSACTIONS] Transactions array:", response.data?.transactions);
        console.log("[TRANSACTIONS] Transactions array type:", Array.isArray(response.data?.transactions));
        console.log("[TRANSACTIONS] Transactions length:", response.data?.transactions?.length);
        
        if (!response.data) {
          console.error("[TRANSACTIONS] No data in response!");
          this.transactions = [];
          return;
        }
        
        if (!response.data.transactions) {
          console.error("[TRANSACTIONS] No transactions field in response.data!");
          console.log("[TRANSACTIONS] Available fields:", Object.keys(response.data));
          this.transactions = [];
          return;
        }
        
        if (!Array.isArray(response.data.transactions)) {
          console.error("[TRANSACTIONS] transactions is not an array!", typeof response.data.transactions);
          this.transactions = [];
          return;
        }
        
        console.log("[TRANSACTIONS] Processing transactions, count:", response.data.transactions.length);
        const grouped = this.groupAndSortHistoryByDate(response.data.transactions);
        console.log("[TRANSACTIONS] Grouped transactions:", grouped);
        console.log("[TRANSACTIONS] Grouped transactions type:", typeof grouped);
        console.log("[TRANSACTIONS] Grouped transactions is array:", Array.isArray(grouped));
        this.transactions = grouped;
        console.log("[TRANSACTIONS] this.transactions set to:", this.transactions);
        console.log("[TRANSACTIONS] this.transactions length:", this.transactions?.length);
      } catch (err) {
        console.error("[TRANSACTIONS] Error occurred:", err);
        console.error("[TRANSACTIONS] Error message:", err.message);
        console.error("[TRANSACTIONS] Error response:", err.response);
        console.error("[TRANSACTIONS] Error response data:", err.response?.data);
        console.error("[TRANSACTIONS] Error response status:", err.response?.status);
        this.transactions = [];
      }
    },
  },
  mounted() {
    console.log("[ACTIVE_COMPONENT] Component mounted");
    console.log("[ACTIVE_COMPONENT] Route params:", this.$route.params);
    console.log("[ACTIVE_COMPONENT] Route params.id:", this.$route.params.id);
    this.initializeUser();
    console.log("[ACTIVE_COMPONENT] User initialized:", {
      user: this.user,
      botId: this.botId,
    });
    this.fetchActives();
  },
  watch: {
    transactions(newVal, oldVal) {
      console.log("[ACTIVE_COMPONENT] transactions changed:", {
        old: oldVal,
        new: newVal,
        oldType: typeof oldVal,
        newType: typeof newVal,
        oldIsArray: Array.isArray(oldVal),
        newIsArray: Array.isArray(newVal),
        oldLength: oldVal?.length,
        newLength: newVal?.length,
      });
    },
  },
  components: {
    BackButton,
  },
};
</script>
<style scoped>
.home {
  padding: 5% 3% 5% 3%;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  background-color: var(--background-color);
  height: 100vh;
  max-width: 100vw;
  align-items: center;
  overflow-y: auto;
}
.active_block {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  width: 100%;
}
.currency_logo {
  width: 100px;
  height: 100px;
}
.buttons {
  display: flex;
  gap: 10px;
  width: 100%;
}
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding-top: 7px;
  padding-bottom: 7px;
  color: #007aff;
  font-size: 13px;
  background-color: var(--button-background);
  border-radius: 15px;
  cursor: pointer;
  width: 100%;
}
.balance_text {
  font-family: "SF Pro Text";
  font-size: 17px;
  color: #79787b;
}
.balanceBlock {
  color: var(--text-color1);
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  font-weight: 600;
  font-family: "SF Compact Rounded";
}

.balanceBlock p {
  font-family: "SF Compact Rounded";
}

.balanceBlock span {
  color: var(--black-to-white);
  opacity: 0.3;
}

.balanceBlock p span {
  color: var(--text-color2);
  opacity: 1;
  font-family: "SF Compact Rounded";
}
.history_block {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: left;
  width: 100%;
}
.history_head {
  font-size: 18px;
  font-family: "SF Pro Text Bold";
}
.transactions_list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.transaction {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.date_name {
  text-transform: uppercase;
  color: var(--black-to-white);
  opacity: 0.3;
  font-size: 14px;
  font-family: "SF Pro Text";
}
.history_transactions {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}
.separator {
  width: 90%;
  height: 0.33px; /* Толщина линии */
  background-color: #555555; /* Цвет линии */
  margin: 8px 0; /* Отступ сверху и снизу */
  align-self: flex-end;
  opacity: 0.3;
}
.trans {
  display: flex;
  flex-direction: column;
}
.trans_block {
  display: flex;
  align-items: center;
  gap: 10px;
}
.trans_block img {
  width: 46px;
}
.trans_text_block {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.trans_line {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.trans_type {
  font-size: 16px;
}
.trans_amount {
  font-size: 16px;
}
.trans_amount.deposit {
  color: #27c12d;
}
.trans_amount.withdraw {
  color: var(--black-to-white);
}
.trans_date,
.trans_fiat {
  font-size: 14px;
  color: var(--black-to-white);
  opacity: 0.3;
}
.empty_history {
  color: var(--black-to-white);
  opacity: 0.5;
}
</style>
